// extracted by mini-css-extract-plugin
module.exports = {"banner":"orientation-banner_banner__MzaRX","title":"orientation-banner_title__QM1u9"};